import React from 'react';
import styled from 'styled-components';
import {
  CpBody03Secondary,
  CpHeading02Primary,
} from 'components/atoms/customer-portal/typography';
import { useGetBackground } from 'components/organisms/customer-portal/types/utils';
import { CpSectionWrapper } from '../../common';
import { CpHeroSectionVariantWidgetProps } from '../types';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  overflow-y: hidden;
  gap: var(--cp-spacing-10);
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: var(--cp-spacing-07);
`;

const Image = styled.img`
  width: 100%;
  height: 600px;
  object-fit: cover;
  object-position: bottom;

  @media (max-width: 780px) {
    width: 100%;
    height: 100%;
  }
`;

const Title = styled(CpHeading02Primary)`
  text-align: center;
  margin-bottom: 0;
  max-width: 768px;

  @media (max-width: 780px) {
    width: 70%;
  }

  @media (max-width: 480px) {
    width: 90%;
  }
`;

const Description = styled(CpBody03Secondary)`
  text-align: center;
  max-width: 800px;

  @media (max-width: 780px) {
    width: 70%;
  }

  @media (max-width: 480px) {
    width: 90%;
  }
`;

export const CpHeroSectionImageAtBottom: React.FC<CpHeroSectionVariantWidgetProps> =
  ({ disabled, data, widget }) => {
    const background = useGetBackground(widget);

    return (
      <CpSectionWrapper
        paddingY={widget?.widgetDefinition?.styles?.paddingY as number}
        isDisabled={disabled}
        background={background}
        data-builder-mode-full-tile="true"
      >
        <Wrapper>
          <ContentWrapper>
            <Title autoAdjustColor id="hero-title">
              {data.title}
            </Title>
            <Description autoAdjustColor>{data.description}</Description>
          </ContentWrapper>

          {data?.heroSectionImage?.attachment?.location && (
            <Image src={data?.heroSectionImage?.attachment?.location} />
          )}
        </Wrapper>
      </CpSectionWrapper>
    );
  };
